import { Component, inject, signal } from "@angular/core";
import { ConfirmationService, PrimeTemplate } from "primeng/api";
import { CategoryService } from "src/app/services/categories.service";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { Tags } from "src/app/models/tags";
import { TagsService } from "src/app/services/tags.service";
import {
  PARAM_TAGS_PATH,
  PARAM_WORKS_PATH,
} from "src/app/constants/constants";
import { TypeService } from "src/app/services/type.service";
import { Type } from "src/app/models/type";
import { WorksService } from "src/app/services/works.service";
import { Works } from "src/app/models/works";
import { Bind } from "primeng/bind";
import { Drawer } from "primeng/drawer";
import { FormsModule } from "@angular/forms";
import { InputText } from "primeng/inputtext";
import { ButtonDirective } from "primeng/button";

import { TableModule } from "primeng/table";
import { NgxPaginationModule } from "ngx-pagination";
import { ConfirmDialog } from "primeng/confirmdialog";
import { TranslatePipe } from "@ngx-translate/core";

import { DynamicFiltersComponent } from "../../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-manage-works",
    templateUrl: "./manage-works.component.html",
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, ButtonDirective, RouterLink, TableModule, NgxPaginationModule, ConfirmDialog, TranslatePipe]
})
export class ManageWorksComponent extends AbstractListController<Works, any> {
  protected workService: WorksService;
  protected confirmationService: ConfirmationService;

  title = "Animali";
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);

  constructor() {
    const workService = inject(WorksService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(workService, confirmationService, router, route, PARAM_WORKS_PATH);
    this.workService = workService;
    this.confirmationService = confirmationService;

    this.cols.set([
      { field: "is_active", header: "Attivo", index: 1 },
      { field: "name", header: "Nome", index: 1 },
      { field: "description", header: "Descrizione", index: 2 },
    ]);
    this.colsFilter.set([
      { field: "name", icon: "pi-tag", header: "Nome", type: "string" },
      { field: "description", icon: "pi-align-left", header: "Descrizione", type: "string" },
    ]);


    this.columnOptions.set([]);
    this.selectedColumns.set([]);
    for (let i = 0; i < this.cols().length; i++) {
      this.columnOptions.update((a) => { a.push({
        label: this.cols()[i].header,
        value: this.cols()[i],
      }); return [...a]; });
    }
  }




}
